import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-danger */
import React from "react";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ItemEventChangeValueTypeDomainService from "../../../Domain/ItemEventChangeValueType/ItemEventChangeValueType.service";
import DateService from "../../../Services/Shared/Date.service";
const HTML = (props) => (_jsx("div", { className: "border p-3 custom-scrollbar", style: { height: 100, overflowY: "auto" }, dangerouslySetInnerHTML: {
        __html: props.value,
    } }));
const DateDisplay = (props) => (_jsx("div", { children: props.value ? (DateService.displayWithTime(new Date(props.value), true)) : (_jsx("em", { className: "text-muted", children: "No Date" })) }));
const ItemEventChangeValueDisplay = (props) => {
    switch (props.item.itemEventChangeValueTypeId) {
        case ItemEventChangeValueTypeDomainService.HTML_ID:
            return _jsx(HTML, { value: props.item.displayName });
        case ItemEventChangeValueTypeDomainService.DATE_ID:
            return _jsx(DateDisplay, { value: props.item.displayName });
        default:
            return props.item.displayName;
    }
};
const List = ({ pair }) => {
    const isInList = React.useCallback((changeValue, otherList) => otherList
        .map((val) => val.idLong || val.idUUID || val.displayName)
        .includes(changeValue.idLong || changeValue.idUUID || changeValue.displayName), []);
    return (_jsxs("div", { className: "row w-100", children: [_jsx("div", { className: "col", children: pair.oldValue.changeValues.map((val, key) => (_jsx("span", { className: `badge mr-2 ${isInList(val, pair.newValue.changeValues)
                        ? "badge-light"
                        : "badge-danger"}`, children: val.displayName }, key))) }), _jsx("div", { className: "col-1 d-flex align-items-center h-100 justify-content-center", children: _jsx(FAIcon, { icon: "arrow-right" }) }), _jsx("div", { className: "col", children: pair.newValue.changeValues.map((val, key) => (_jsx("span", { className: `badge mr-2 ${isInList(val, pair.oldValue.changeValues)
                        ? "badge-light"
                        : "badge-success"}`, children: val.displayName }, key))) })] }));
};
const NotList = ({ pair }) => {
    return (_jsxs("div", { className: "row w-100", children: [_jsx("div", { className: "col", children: _jsx(ItemEventChangeValueDisplay, { item: pair.oldValue.changeValues[0] }) }), _jsx("div", { className: "col-auto d-flex align-items-center h-100 justify-content-center", children: _jsx(FAIcon, { icon: "arrow-right" }) }), _jsx("div", { className: "col", children: _jsx(ItemEventChangeValueDisplay, { item: pair.newValue.changeValues[0] }) })] }));
};
const ItemEventChangePairListItem = (props) => {
    return (_jsxs("div", { children: [_jsx("div", { className: "font-weight-bold", children: props.pair.displayName }), _jsx("div", { className: "d-flex mb-3", children: props.pair.oldValue.isList ? (_jsx(List, { pair: props.pair })) : (_jsx(NotList, { pair: props.pair })) })] }));
};
export default ItemEventChangePairListItem;
